import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function Pricing() {
  const {
    t
  } = useLanguage();
  const plans = [{
    nameKey: 'pricing.basic',
    price: '$40',
    periodKey: 'pricing.month',
    isPopular: false
  }, {
    nameKey: 'pricing.standard',
    price: '$100',
    periodKey: 'pricing.quarter',
    isPopular: true
  }, {
    nameKey: 'pricing.premium',
    price: '$300',
    periodKey: 'pricing.year',
    isPopular: false
  }];
  return <section className="py-32 bg-svt-bg relative transition-colors duration-300" data-id="element-129">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-svt-purple/10 blur-[120px] rounded-full pointer-events-none" data-id="element-130"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-132">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-svt-text" data-id="element-133">
            {t('pricing.title')}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto items-center" data-id="element-134">
          {plans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative p-10 rounded-3xl flex flex-col items-center text-center transition-all duration-300 ${plan.isPopular ? 'bg-svt-card-highlight border border-svt-pink/40 shadow-[0_0_40px_rgba(232,67,147,0.15)] md:scale-105 z-10' : 'bg-svt-card-alt border border-svt-border hover:border-svt-border-hover'}`} data-id="element-135">
              {plan.isPopular && <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-6 py-1.5 rounded-full bg-gradient-primary text-white text-xs font-bold tracking-widest uppercase shadow-[0_0_20px_rgba(232,67,147,0.4)]" data-id="element-136">
                  {t('pricing.popular')}
                </div>}

              <h3 className="text-2xl font-bold mb-4 mt-2 text-svt-text" data-id="element-137">
                {t(plan.nameKey)}
              </h3>
              <p className="text-svt-text-muted text-sm mb-8" data-id="element-138">
                {t('pricing.trial')}
              </p>

              <div className="mb-10 flex items-baseline justify-center gap-1" data-id="element-139">
                <span className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-svt-pink to-svt-purple" data-id="element-140">
                  {plan.price}
                </span>
                <span className="text-svt-text-muted text-lg" data-id="element-141">
                  {t(plan.periodKey)}
                </span>
              </div>

              <button className={`mt-auto w-full py-4 rounded-full font-medium transition-all duration-300 ${plan.isPopular ? 'bg-gradient-primary text-white shadow-[0_0_20px_rgba(232,67,147,0.4)] hover:shadow-[0_0_30px_rgba(232,67,147,0.6)] hover:scale-[1.02]' : 'border border-svt-pink/50 text-svt-pink-light hover:bg-svt-pink/10 hover:border-svt-pink'}`} data-id="element-142">
                {t('pricing.select')}
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}